import {IAdminTicketsResponse} from "../../api/ticketService";

export interface ITicketsState {
    loading: boolean
    fetchLoading: boolean
    userTickets: IUserTicket[]
    adminTickets: IAdminTicketsResponse
    adminTicketsLoading: boolean
}

enum TicketStatus {
    ACTIVE = 'ACTIVE',
    REDEEMED = 'REDEEMED',
    EXPIRED = 'EXPIRED',
}

export interface IUserTicket {
    id: string
    cost: number
    user_id: string
    user: {
        full_name: string
        email: string
    }
    wish_id: string
    created_at: string
    winner: boolean
    qr_code: string | null
    code: string
    status: TicketStatus
    voucher_expiry: string | null
    comment: string | null
    recipient_name: string | null
    recipient_email: string | null
    points: number | null
    bundle_wish_id: string | null
    bundle_wish_name_en: string | null
    bundle_wish_name_mk: string | null
    bundle_wish_name_al: string | null
}

export const initialAdminTicketsState: IAdminTicketsResponse = {
    total_pages: 0,
    count: 0,
    data: [],
}
